import { render, staticRenderFns } from "./RuleBox.vue?vue&type=template&id=c304a114&scoped=true"
import script from "./RuleBox.vue?vue&type=script&lang=js"
export * from "./RuleBox.vue?vue&type=script&lang=js"
import style0 from "./RuleBox.vue?vue&type=style&index=0&id=c304a114&prod&lang=scss&scoped=true"
import style1 from "./RuleBox.vue?vue&type=style&index=1&id=c304a114&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c304a114",
  null
  
)

export default component.exports